import { NgModule } from '@angular/core';
import { LucideAngularModule, RotateCw } from 'lucide-angular';

const lucide = LucideAngularModule.pick({ RotateCw });

@NgModule({
  imports: [lucide],
  exports: [LucideAngularModule],
})
export class PageRefreshIconsModule {}
